module.exports = __webpack_public_path__ + "img/11passenger_parked.72fa9e3c.svg";